<template>
    <v-card style="position: absolute; width: 100%">
        <v-card-title>Reports</v-card-title>
        <v-list>
            <v-list-item-group>
                <v-divider></v-divider>
                <v-list-item :ripple="false">
                    <v-list-item-content>
                        <v-list-item-title>Guest List</v-list-item-title>
                        <v-list-item-subtitle>Can be imported to system directly</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn color="primary" @click="onClickDownloadGuestReport">
                            Export
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item :ripple="false">
                    <v-list-item-content>
                        <v-list-item-title>Agenda Group Report</v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn color="primary" @click="$router.push({name: 'event-report-agenda-group'})">
                            Export
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item :ripple="false">
                    <v-list-item-content>
                        <v-list-item-title>General Report</v-list-item-title>
                        <v-list-item-subtitle>Number of ppl that enable private acc / Number of ppl that enable notification / Number of ppl press delete acc</v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn color="primary" @click="$router.push({name: 'event-report-general'})">
                            Export
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item :ripple="false">
                    <v-list-item-content>
                        <v-list-item-title>Business Matching Report</v-list-item-title>
                        <v-list-item-subtitle></v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                        <v-btn color="primary" @click="$router.push({name: 'event-report-business-matching'})">
                            Export
                            <v-icon right>mdi-download</v-icon>
                        </v-btn>
                    </v-list-item-action>
                </v-list-item>
                <v-list-item @click="isActive = !isActive">
                <v-list-item-content>
                    <v-list-item-title>App Action and Chatroom Report</v-list-item-title>
                    <v-list-item-subtitle>Count of action button clicks and Number of ppl that using chatroom</v-list-item-subtitle>
                </v-list-item-content>
                    <v-list-item-action>
                        <v-icon>{{ isActive ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-list-item-action>
                </v-list-item>
                <v-expand-transition transition="scroll-y-transition">
                    <v-card v-if="isActive" flat>
                        <v-list-item :ripple="false" inactive>
                            <v-list-item-content>
                                <v-container fluid>
                                    <v-row>
                                        <v-btn color="primary" @click="$router.push({name: 'event-report-app-action', params: {isTemplate: 1}})" class="mb-4">
                                            Excel Template
                                            <v-icon right>mdi-download</v-icon>
                                        </v-btn>
                                    </v-row>
                                    <v-row>
                                        <v-file-input class="mt-4"
                                            outlined
                                            prepend-icon=""
                                            prepend-inner-icon="$file"
                                            accept=".xlsx, .xls, .csv"
                                            label="Import File"
                                            placeholder="Select..."
                                            @change="uploadExcel"></v-file-input>
                                    </v-row>
                                    <v-row>
                                        <v-chip
                                            label
                                            small
                                            @click="addRow">
                                            <v-icon>mdi-account-plus</v-icon>
                                        </v-chip>
                                        <v-chip
                                            label
                                            small
                                            @click="removeRow">
                                            <v-icon>mdi-account-minus</v-icon>
                                        </v-chip>
                                    </v-row>
                                    <v-row>
                                        <canvas-datagrid
                                            :data.prop="excelData"
                                            @rendercell="loadDataCheck"
                                            @beforesortcolumn="beforeSortColumn"
                                            style="height: 300px"
                                            id="excelGrid"></canvas-datagrid>
                                    </v-row>
                                    <v-row>
                                        <span>*Please use excel time format for import or [dd/mm/yyyy HH:mm:ss] for direct input</span>
                                    </v-row>
                                    <v-row class="d-flex">
                                        <v-btn color="primary" @click="importCheck" class="mt-4">
                                            Export
                                            <v-icon right>mdi-download</v-icon>
                                        </v-btn>
                                    </v-row>
                                </v-container>
                            </v-list-item-content>
                        </v-list-item>
                    </v-card>
                </v-expand-transition>
            </v-list-item-group>
        </v-list>

        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64"></v-progress-circular>
        </v-overlay>
        
        <RouterView></RouterView>
    </v-card>
</template>

<style scoped>
</style>

<script>
    import {computed, ref, onMounted, watch} from '@vue/composition-api';
    import XLSX from 'xlsx';
    import CanvasDatagrid from 'canvas-datagrid';
    import _ from 'lodash';
    import eConfig from "../../evention-config.js";
    import {DateTime} from "luxon";

    export default {
        name: 'EventReport',
        setup(props, {root}) {
            const eventId = computed(() => root.$route.params.eventId);

            const loginEmail = root.$store.state.auth.user.email;
            
            const isActive = ref(false);
            const dbColMapping = eConfig.reportAppAction.dbColMapping;

            const overlay = ref(false);

            const colOptions = ref(Object.keys(dbColMapping).map((col) => {return {text: col, value: col}}));

            const onClickDownloadGuestReport = () => {
                if (loginEmail.includes('pasla')) {
                    switch (eventId.value) {
                        // Pasla Conference 2026
                        case 'a0711058-fc9a-4bd2-9a22-4886810ab3bb': // Production
                            window.open('https://paslaevent.com/bangkokconference/api/cmsExportRSVPReport', '_blank');
                            break;
                        case 'e96ab950-e3d6-4b52-917d-3fcc00614735': // UAT
                            window.open('https://uat.eventionapp.com/bangkokconference/api/cmsExportRSVPReport', '_blank');
                            break;
                        default:
                            root.$router.push({name: 'event-report-guest'});
                    }
                } else {
                    root.$router.push({name: 'event-report-guest'});
                }
            };

            const readXLSX = (file) => {
                let nameSplit = file.name.split('.');
                let format = nameSplit[nameSplit.length - 1];
                if (!['xls', 'xlsx', 'csv'].includes(format)) {
                    return false;
                }
                return new Promise((resolve) => {
                    let reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = function (evt) {
                        let data = evt.target.result;
                        var workbook = XLSX.read(data, {type: 'binary'});
                        let outdata = XLSX.utils.sheet_to_json(workbook.Sheets[workbook.SheetNames[0]], {defval: ''});
                        resolve(outdata);
                    }
                });
            }

            const uploadExcel = async (f) => {
                if (f) {
                    const outdata = await readXLSX(f);
                    excelData.value = outdata;
                } else {
                    excelData.value = JSON.parse(JSON.stringify(excelData_init));
                }
                
                if (excelData.value && excelData.value.length >= 1) {
                    colOptions.value = Object.keys(excelData.value[0]).map((col) => {return {text: col, value: col}});
                    // convert excel date format to js date
                    for (let g of excelData.value) {
                        if (g.hasOwnProperty('Start Time') && g['Start Time']) g['Start Time'] = DateTime.fromJSDate(new Date(Math.round((g['Start Time'] - 25569)*86400*1000))).setZone('Etc/GMT').toFormat('dd/LL/yyyy HH:mm:ss');
                        if (g.hasOwnProperty('End Time') && g['End Time']) g['End Time'] = DateTime.fromJSDate(new Date(Math.round((g['End Time'] - 25569)*86400*1000))).setZone('Etc/GMT').toFormat('dd/LL/yyyy HH:mm:ss');
                    }
                }
                return false;
            };

            const checkValue = (header, value) => {
                // check if date string is convertable to date
                if (header === 'Start Time') {
                    if (value !== 'Start Time' && isNaN(DateTime.fromFormat(value, 'dd/LL/yyyy HH:mm:ss')) || value === '') {
                        return false;
                    }
                }
                if (header === 'End Time') {
                    if (value !== 'End Time' && isNaN(DateTime.fromFormat(value, 'dd/LL/yyyy HH:mm:ss')) || value === '') {
                        return false;
                    }
                }
                return true;
            };
            
            const loadDataCheck = (e) => {
                if (!_.isEqual(excelData.value, excelData_init)) {
                    if (!checkValue(e.cell.header.name, e.cell.value)) {
                        e.ctx.fillStyle = '#FFAAAA';
                    }
                }
            };

            const importCheck = async () => {    
                if (!excelData.value[0].hasOwnProperty('Start Time') || !excelData.value[0].hasOwnProperty('End Time')) {
                    root.$store.dispatch('showSnackBar', 'Invalid Format');
                    return false;
                }
                
                for (let y = 0; y < excelData.value.length; y++) {
                    let rowValid = Object.keys(excelData.value[y]).every((header) => { return checkValue(header, excelData.value[y][header]); });
                    if (!rowValid) {
                        root.$store.dispatch('showSnackBar', 'Row #' + (y + 1) + ' is not valid');
                        return false;
                    }
                }

                root.$router.push({name: 'event-report-app-action', params: {isTemplate: 0, timeslots: excelData.value.map((row) => [DateTime.fromFormat(row['Start Time'], 'dd/LL/yyyy HH:mm:ss').toISO(), DateTime.fromFormat(row['End Time'], 'dd/LL/yyyy HH:mm:ss').toISO()])}});

                return true;
            };

            const excelData_init = [{
                'Start Time': DateTime.local().set({
                    hour: 0,
                    minute: 0,
                    second: 0,
                    millisecond: 0
                }).toFormat('dd/LL/yyyy HH:mm:ss'),
                'End Time': DateTime.local().set({
                    hour: 23,
                    minute: 59,
                    second: 59,
                    millisecond: 0
                }).toFormat('dd/LL/yyyy HH:mm:ss'),
                // ...Object.keys(dbColMapping).reduce((reduced, key) => ({ ...reduced, [key]: '' }), {})
            }];
            const excelData = ref(JSON.parse(JSON.stringify(excelData_init)));
            
            const beforeSortColumn = (e) => {
                e.preventDefault();
            };
            
            const addRow = () => {
                document.getElementById('excelGrid').addRow({});
            };
            
            const removeRow = () => {
                let rowSelected = document.getElementById('excelGrid').selectedRows.map((row, j) => !!row && j).filter(j => j !== false && j >= 0).reverse();
                if (rowSelected.length >= 1 && document.getElementById('excelGrid').selections.every(row => !row || !row.length || row.length === document.getElementById('excelGrid').columnOrder.length + 1)) {
                    if (excelData.value.length - rowSelected.length >= 1) {
                        rowSelected.forEach(j => document.getElementById('excelGrid').deleteRow(j));
                    } else {
                        excelData.value = JSON.parse(JSON.stringify(excelData_init));
                    }
                } else {
                    root.$store.dispatch('showSnackBar', 'Please select entire row(s) by clicking row number.');
                }
            };

            onMounted(() => {
                watch(isActive, (newValue) => {
                    if (newValue) {
                        document.getElementById('excelGrid').style.width = '100%';
                        document.getElementById('excelGrid').controlInput.onblur = () => {
                            if (document.getElementById('excelGrid') && document.getElementById('excelGrid').input) {
                                document.getElementById('excelGrid').input.onblur = () => {
                                    document.getElementById('excelGrid').endEdit(false);
                                }
                            }
                        };
                    }
                })
            });

            return {
                eventId,
                isActive,
                overlay,
                excelData,
                CanvasDatagrid,
                beforeSortColumn,
                addRow,
                removeRow,
                uploadExcel,
                importCheck,
                loadDataCheck,
                onClickDownloadGuestReport,
            }
        },
    }
</script>
